import { TableActionVariablesType } from 'modules/ui/Table/types';

export const actionsList: TableActionVariablesType[] = ['onEdit', 'onRemove'];

export const rowHeights = {
  big: 41,
  small: 33,
};
